(() => {
  const init = root => {
    if (root.dataset.careersReady) return;
    root.dataset.careersReady = 'true';
    root.querySelectorAll('a[href="#apply"],a[href="#open-roles"]').forEach(link => link.addEventListener('click', () => {
      const target = root.querySelector(link.getAttribute('href'));
      target?.setAttribute('tabindex', '-1');
      target?.focus({preventScroll:true});
    }));
  };
  document.querySelectorAll('[data-rival-careers]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rival-careers]').forEach(init));
})();
